import React from "react";
import { AuthContext } from "../../providers/authContext";
import Header from "../../components/Header";
import { IonContent, IonPage } from "@ionic/react";
import { SERVER_URL } from "../../services/constants";

const MobilGizlilik: React.FC = () => {
  const { kurumBilgileri } = React.useContext(AuthContext);

  return (
    <IonPage>
      <Header />
      <IonContent fullscreen className="ion-padding">
        <h3>
          <b>
            E-BELEDİYE HİZMETLERİ GİZLİLİK POLİTİKASI
          </b>
        </h3>
        <h5><b>Son Güncelleme:</b>16/03/2026</h5>

        <div style={{ textAlign: "justify" }}>
          <span style={{ textAlign: "justify" }}>
            <h6>
              {kurumBilgileri?.kisaTanim} olarak, kullanıcılarımızın gizliliğine ve kişisel verilerinin korunmasına büyük önem veriyoruz. Bu gizlilik politikası, mobil uygulamamız aracılığıyla toplanan verilerin türünü, kullanım amacını ve güvenliğini açıklamaktadır.
            </h6>
            <h4>
              <b>
                1. Toplanan Veriler ve Kullanım Amaçları
              </b>
            </h4>
            <h6>
              Uygulamamız, belediyecilik hizmetlerini dijital ortamda sunabilmek adına aşağıdaki verileri işlemektedir:
              <ul>
                <li><b>Kimlik Bilgileri:</b> Giriş yapan kullanıcılar için T.C. Kimlik No, Ad-Soyad gibi belediye veritabanında eşleşen bilgiler.</li>
                <li><b>Finansal Bilgiler:</b> Borç sorgulama ve ödeme işlemleri sırasında işlem kayıtları (Ödeme işlemleri güvenli banka altyapısı üzerinden yapılır; <b>kredi kartı bilgileriniz tarafımızca saklanmaz</b>).</li>
                <li><b>NFC Verileri:</b> Akıllı su kartı bakiyesi sorgulama ve yükleme işlemleri için cihazın NFC (Near Field Communication) özelliği kullanılır. Bu işlem sırasında sadece kart kimlik numarası ve bakiye bilgisi işlenir.</li>
              </ul>
            </h6>
            <h4>
              <b>
                2. Verilerin İşlenme Yöntemi
              </b>
            </h4>
            <h6>
              <ul>
                <li>
                 <b>Giriş Yapmadan Kullanım:</b> Borç sorgulama ve ödeme işlemleri, sadece ilgili Sicil/Abone/T.C. numarası ile belediye veritabanından anlık çekilmektedir.
                </li>
                <li>
                  <b>Veritabanı Saklama:</b> Kullanıcı bilgileri ve işlem geçmişi, belediyenin kendi güvenli sunucularında (Veritabanı) saklanmaktadır.
                </li>
              </ul>
            </h6>
            <h4>
              <b>
                3. Üçüncü Taraflarla Veri Paylaşımı
              </b>
            </h4>
            <h6>
              Toplanan veriler, yasal yükümlülükler veya ödeme sistemlerinin (Bankalar/Ödeme Kuruluşları) teknik gereksinimleri haricinde, pazarlama veya reklam amacıyla <b>asla 3. parti şahıs ve kurumlarla paylaşılmamaktadır.</b>
            </h6>
            <h4>
              <b>
                4. Cihaz İzinleri
              </b>
            </h4>
            <h6>
              Uygulama, işlevselliğini yerine getirmek için şu izinleri talep eder:
              <ul>
                <li><b>NFC Erişimi:</b> Su kartlarına bakiye yüklemek ve okumak için gereklidir.</li>
                <li>
                  <b>İnternet Erişimi:</b> Belediye veritabanı ile senkronizasyon ve ödeme işlemleri için gereklidir.
                </li>
              </ul>
            </h6>
            <h4>
              <b>
                5. Veri Silme ve Kullanıcı Hakları
              </b>
            </h4>
            <h6>
              Kullanıcılar, KVKK kapsamında verilerinin işlenip işlenmediğini öğrenme ve silinmesini talep etme hakkına sahiptir. Hesap silme veya veri temizleme taleplerinizi {kurumBilgileri?.eposta} üzerinden bize iletebilirsiniz.
            </h6>
            <h4>
              <b>
                6. İletişim
              </b>
            </h4>
            <h6>
              Bu politika hakkında sorularınız için: <b>
              <br />
              {kurumBilgileri?.adres} / Tel: {kurumBilgileri?.telefon} / {kurumBilgileri?.eposta}
          </b> üzerinden bizimle iletişime geçebilirsiniz.
            </h6>
          </span>
        </div>
      </IonContent>
    </IonPage>
  );
};
export default React.memo(MobilGizlilik);
